import { GridColDef } from "@mui/x-data-grid";
import { formatDate } from "../../../helpers/formatingFunctions";
import ConfirmActionButton from "../../../components/Fleet/ConfirmActionButton/ConfirmActionButton";
import UpdateRentPaymentPopup from "../../../components/Fleet/UpdateRentPaymentPopup/UpdateRentPaymentPopup";

export const rentPaymentTableColumns: GridColDef[] = [
  { field: "billToCompanyName", headerName: "Bill To", width: 150 },
  {
    field: "paymentDate",
    headerName: "Payment Date",
    width: 150,
    valueFormatter: (value) => formatDate(value as string),
  },
  { field: "paymentAmount", headerName: "Payment Amount", width: 150 },
  { field: "paymentMethod", headerName: "Payment Method", width: 150 },
  { field: "createdBy", headerName: "Created By", width: 150 },
  {
    field: "actions",
    headerName: "",
    width: 200,
    renderCell: (params) => <UpdateRentPaymentPopup rentPayment={params.row} />,
  },
  {
    field: "delete",
    headerName: "",
    width: 130,
    renderCell: (params) => (
      <ConfirmActionButton
        id={params.row.id}
        entityType="RentPayment"
        actionType="delete"
        entityLabel="rent payment"
        queryKey="rentPayments"
        buttonLabel="Delete"
        buttonColor="error"
      />
    ),
  },
];
